module.exports = __webpack_public_path__ + "static/assets/6b7cb6ae65beb0c64262c053f24a0bca.gif";